<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入直播标题" v-model="params.title" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.userId" class="input-with-select" size="small">
                        <el-select v-model="params.userType" slot="prepend" placeholder="请选择">
                            <el-option label="直播用户ID" :value="1"></el-option>
                            <el-option label="推流用户ID" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="6" :sm="6" :md="8" :lg="9" :xl="8">
                    <el-date-picker
                        v-model="daterange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="直播时间"
                        end-placeholder="直播时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        unlink-panels
                        size="small">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/live/event/create')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" @click="add" size="small">新增直播事件</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="title" label="直播标题" min-width="180">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.title" placement="top">
                            <span class="ellipsis" >{{ scope.row.title }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="liveUserName" label="直播用户" min-width="100">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.liveUserName" placement="top">
                            <span class="ellipsis" >{{ scope.row.liveUserName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="pushUserName" label="推流用户" min-width="100">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.pushUserName" placement="top">
                            <span class="ellipsis" >{{ scope.row.pushUserName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="beginTime" label="开始时间" min-width="170"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" min-width="170"></el-table-column>
                <el-table-column prop="playbackUrl" label="回放链接">
                    <template slot-scope="scope">
                        <el-link :href="`${scope.row.playbackUrl}`" target="_blank" class="ellipsis">{{scope.row.playbackUrl}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" size="mini" type="success">正常</el-tag>
                        <el-tag v-else size="mini" type="info">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="serialNum" label="序号"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/live/event/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <template v-if="$utils.have('/live/event/updateStatus')">
                            <el-button
                                v-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                icon="el-icon-remove-outline"
                                @click="editStatus(scope.row.id,0)"
                                >隐藏</el-button
                            >
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                icon="el-icon-circle-check"
                                @click="editStatus(scope.row.id,1)"
                                >显示</el-button
                            >
                        </template>
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-document-copy"
                            @click="copy(scope.row.id)"
                            >复制链接</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <input class="copyTool" ref="copyTool" :value="copyValue" />
        <edit ref="dataEdit" @update="getDataList"></edit>
    </div>
</template>
<script>
import Edit from './components/edit'
const defaultParams = {
    pageNo: 1,
    title: '',
    beginTime: '',
    endTime:'',
    userType:1,
    userId:''
}
export default {
    components:{Edit},
    data(){
        return {
            data: null,
            dataList: null,
            daterange: '',
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            listLoading: true,
            copyValue:'',
            copyTimer:null
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList(){
            this.listLoading = true;
            this.params = {
                ...this.params,
                beginTime:this.daterange ? this.daterange[0] : '',
                endTime:this.daterange ? this.daterange[1] : '',
            }
            this.$request({
                url: '/live/event/list',
                method: 'POST',
                data: this.params
            }).then(res => {
                const { state, msg, result } = res.data;
                if( state == 1 && result ){
                    this.data = result;
                    this.dataList = result.result || [];
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },
        //选择pageSize
        handleSizeChange( e ){
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.daterange = "";
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize
            }
            this.getDataList();
        },
        //复制链接
        copy(id){
            this.copyValue = `${process.env.VUE_APP_SSWAP_URL}/pages/live/event/event?id=${id}`;
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
        //改变状态
        editStatus(id,status){
            const _msg = status === 0 ? '确定要隐藏吗?' : '确定要显示吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/live/event/updateStatus',
                    method: 'POST',
                    params: {id:id,status:status}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => {})
        },
        //新增事件
        add(){
            this.$refs.dataEdit.show();
        },
        //编辑事件
        edit(id) {
            this.$refs.dataEdit.show(id);
        }   
    }
}
</script>

<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
}
</style>